import type {AppTopbarRef, ColorScheme} from "../../types";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {forwardRef, useContext, useImperativeHandle, useRef} from "react";
import AppBreadcrumb from "./AppBreadCrumb";
import {LayoutContext} from "./context/LayoutContext";
import {Avatar} from "primereact/avatar";
import {PrimeReactContext} from "primereact/api";
import {Badge} from "primereact/badge";
import {useAuth} from "../../hooks/useAuth";


const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {
    const {
        onMenuToggle,
        showProfileSidebar,
        layoutConfig,
        setLayoutConfig,
    } = useContext(LayoutContext);
    const menubuttonRef = useRef(null);

    const {unreadNotification}  = useAuth();

    const {changeTheme} = useContext(PrimeReactContext);

    // const onConfigButtonClick = () => {
    //     showConfigSidebar();
    // };

    useImperativeHandle(ref, () => ({
        menubutton: menubuttonRef.current,
    }));

    const changeColorScheme = (colorScheme: ColorScheme) => {
        // console.log(colorScheme,'toggle button')
        changeTheme?.(layoutConfig.colorScheme, colorScheme, 'theme-link', () => {
            setLayoutConfig((prevState) => ({...prevState, colorScheme}));
            localStorage.setItem('colorScheme', colorScheme)
        });
    };




    return (
        <div className="layout-topbar">
            <div className="topbar-start">
                <button
                    ref={menubuttonRef}
                    type="button"
                    className="topbar-menubutton p-link p-trigger"
                    onClick={onMenuToggle}
                >
                    <i className="pi pi-bars"></i>
                </button>
                <AppBreadcrumb className="topbar-breadcrumb"></AppBreadcrumb>
            </div>

            <div className="topbar-end">
                <ul className="topbar-menu">
                    <li className="topbar-search">
                        <span className="p-input-icon-left">
                            <i className="pi pi-search"></i>
                            <InputText
                                type="text"
                                placeholder="Search"
                                className="w-12rem sm:w-full"
                            />
                        </span>
                    </li>
                    {/*<li className="ml-3 mt-2 cursor-pointer" >*/}
                    {/*    <i className="pi pi-bell relative" style={{ fontSize: '1.4rem',}}*/}

                    {/*    >*/}
                    {/*        {*/}
                    {/*            unreadNotification >0 &&  <Badge style={{bottom: "7px", right: "-15px"}} value={unreadNotification > 10 ? `9+` : unreadNotification} className={"absolute"} severity={"danger"}></Badge>*/}
                    {/*        }*/}
                    {/*    </i>*/}
                    {/*</li>*/}

                    <li className="ml-3">
                        <Button
                            type="button"
                            // icon="pi pi-sun"
                            icon={`${layoutConfig.colorScheme === 'light' ? "pi pi-sun" : "pi pi-moon"}`}
                            text
                            rounded
                            severity="secondary"
                            className="flex-shrink-0"
                            onClick={() => changeColorScheme(layoutConfig.colorScheme === 'light' ? 'dim' : 'light')}
                        ></Button>
                    </li>
                    <li className="ml-3">
                        <Button
                            type="button"
                            // icon="pi pi-sun"
                            icon={<i className="pi pi-bell p-overlay-badge" style={{ fontSize: '1.3rem' }}>
                                <Badge value={unreadNotification} severity="danger"></Badge>
                            </i>}
                            text
                            rounded
                            severity="secondary"
                            className="flex-shrink-0"
                        >

                        </Button>
                    </li>
                    <li className="topbar-profile">
                        <button
                            type="button"
                            className="p-link"
                            onClick={showProfileSidebar}
                        >
                            <Avatar icon={"pi pi-user"} shape="circle" className={"bg-primary"}/>
                            {/*<img*/}
                            {/*    src="/layout/images/avatar/avatar.png"*/}
                            {/*    alt="Profile"*/}
                            {/*/>*/}
                        </button>
                    </li>



                </ul>
            </div>
        </div>
    );
});

AppTopbar.displayName = "AppTopbar";

export default AppTopbar;
